<template>
  <transition name="rm-modal-fade">
    <div class="rm-detail-overlay" v-if="open" @click.self="$emit('close')">
      <div class="rm-detail-modal">

        <!-- ── Header ── -->
        <div class="rm-detail-header">
          <div class="rm-detail-header-left">
            <i class="fa-solid fa-building-columns"></i>
            <div>
              <h2 class="rm-detail-title">Commercial Loan Request</h2>
              <p class="rm-detail-subtitle">{{ item.entityname || '—' }}</p>
            </div>
          </div>
          <button class="rm-detail-close" @click="$emit('close')">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <!-- ── Meta bar ── -->
        <div class="rm-detail-meta-bar">
          <span class="rm-detail-meta-item">
            <i class="fa-regular fa-clock"></i>
            Submitted {{ item.submittedat || '—' }}
          </span>
          <span class="rm-detail-meta-item">
            <i class="fa-regular fa-user-tie"></i>
            {{ item.loname || '—' }}
          </span>
          <span class="rm-detail-meta-item" v-if="item.loanpurpose">
            <i class="fa-regular fa-bullseye-arrow"></i>
            {{ item.loanpurpose }}
          </span>
          <span class="rm-detail-meta-item" v-if="item.loanamountrequested">
            <i class="fa-regular fa-dollar-sign"></i>
            {{ item.loanamountrequested }}
          </span>
        </div>

        <!-- ── Scrollable body ── -->
        <div class="rm-detail-body">

          <!-- LO Information -->
          <div class="rm-detail-section">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-id-card"></i>
              <span>Loan Officer</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Name</span><span class="rm-detail-value">{{ item.loname || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">NMLS ID</span><span class="rm-detail-value">{{ item.lonmlsid || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Email</span><span class="rm-detail-value">{{ item.loemail || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Cell Phone</span><span class="rm-detail-value">{{ item.locellphone || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Office Phone</span><span class="rm-detail-value">{{ item.loofficephone || '—' }}</span></div>
            </div>
          </div>

          <!-- Borrower / Entity -->
          <div class="rm-detail-section">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-building"></i>
              <span>Borrower / Entity</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Entity Name</span><span class="rm-detail-value">{{ item.entityname || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Entity Type</span><span class="rm-detail-value">{{ item.entitytype || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Decision Maker</span><span class="rm-detail-value">{{ item.contactname || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Contact Phone</span><span class="rm-detail-value">{{ item.contactphone || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Contact Email</span><span class="rm-detail-value">{{ item.contactemail || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Years in Business</span><span class="rm-detail-value">{{ item.yearsinbusiness || '—' }}</span></div>
              <div class="rm-detail-field rm-detail-field--full"><span class="rm-detail-label">Business Description</span><span class="rm-detail-value">{{ item.businessdescription || '—' }}</span></div>
              <div class="rm-detail-field rm-detail-field--full"><span class="rm-detail-label">Real Estate Experience</span><span class="rm-detail-value">{{ item.realestateexperience || '—' }}</span></div>
            </div>
          </div>

          <!-- Guarantor -->
          <div class="rm-detail-section" v-if="item.guarantorname">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-user-shield"></i>
              <span>Guarantor</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Name</span><span class="rm-detail-value">{{ item.guarantorname || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Phone</span><span class="rm-detail-value">{{ item.guarantorphone || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Email</span><span class="rm-detail-value">{{ item.guarantoremail || '—' }}</span></div>
            </div>
          </div>

          <!-- Property -->
          <div class="rm-detail-section">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-building-columns"></i>
              <span>Property</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Property Type</span><span class="rm-detail-value">{{ item.propertytype || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Condition</span><span class="rm-detail-value">{{ item.propertycondition || '—' }}</span></div>
              <div class="rm-detail-field rm-detail-field--full"><span class="rm-detail-label">Address</span><span class="rm-detail-value">{{ item.propertyaddress || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">City</span><span class="rm-detail-value">{{ item.propertycity || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">State</span><span class="rm-detail-value">{{ item.propertystate || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">ZIP</span><span class="rm-detail-value">{{ item.propertyzip || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Current Use</span><span class="rm-detail-value">{{ item.currentuse || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Proposed Use</span><span class="rm-detail-value">{{ item.proposeduse || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Approx Value</span><span class="rm-detail-value">{{ item.approxvalue || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Purchase Price</span><span class="rm-detail-value">{{ item.purchaseprice || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Occupancy</span><span class="rm-detail-value">{{ item.currentoccupancy || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Units</span><span class="rm-detail-value">{{ item.numberofunits || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Sq Ft</span><span class="rm-detail-value">{{ item.squarefootage || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Year Built</span><span class="rm-detail-value">{{ item.yearbuilt || '—' }}</span></div>
              <div class="rm-detail-field rm-detail-field--full"><span class="rm-detail-label">Rent Roll Summary</span><span class="rm-detail-value">{{ item.rentrollsummary || '—' }}</span></div>
            </div>
          </div>

          <!-- The Ask -->
          <div class="rm-detail-section">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-hand-holding-dollar"></i>
              <span>The Ask</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Loan Amount</span><span class="rm-detail-value">{{ item.loanamountrequested || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Loan Purpose</span><span class="rm-detail-value">{{ item.loanpurpose || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Timeline</span><span class="rm-detail-value">{{ item.timeline || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Existing Lender</span><span class="rm-detail-value">{{ item.existinglender || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Existing Balance</span><span class="rm-detail-value">{{ item.existingbalance || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Maturity Date</span><span class="rm-detail-value">{{ item.existingmaturitydate || '—' }}</span></div>
              <div class="rm-detail-field rm-detail-field--full"><span class="rm-detail-label">Additional Notes</span><span class="rm-detail-value">{{ item.additionalnotes || '—' }}</span></div>
            </div>
          </div>

          <!-- Financials -->
          <div class="rm-detail-section">
            <div class="rm-detail-section-header">
              <i class="fa-solid fa-chart-pie"></i>
              <span>Borrower Financials</span>
            </div>
            <div class="rm-detail-grid">
              <div class="rm-detail-field"><span class="rm-detail-label">Est. Net Worth</span><span class="rm-detail-value">{{ item.estnetworth || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Est. Liquidity</span><span class="rm-detail-value">{{ item.estliquidity || '—' }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Credit Issues</span><span :class="['rm-detail-badge', boolBadge(item.creditissues)]">{{ boolLabel(item.creditissues) }}</span></div>
              <div class="rm-detail-field rm-detail-field--full" v-if="item.creditissuesdetail"><span class="rm-detail-label">Credit Detail</span><span class="rm-detail-value">{{ item.creditissuesdetail }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Bankruptcies</span><span :class="['rm-detail-badge', boolBadge(item.bankruptcies)]">{{ boolLabel(item.bankruptcies) }}</span></div>
              <div class="rm-detail-field rm-detail-field--full" v-if="item.bankruptcydetail"><span class="rm-detail-label">Bankruptcy Detail</span><span class="rm-detail-value">{{ item.bankruptcydetail }}</span></div>
              <div class="rm-detail-field"><span class="rm-detail-label">Other RE Owned</span><span :class="['rm-detail-badge', boolBadge(item.otherRealEstateOwned)]">{{ boolLabel(item.otherRealEstateOwned) }}</span></div>
              <div class="rm-detail-field" v-if="item.numpropertiesowned"><span class="rm-detail-label"># Properties</span><span class="rm-detail-value">{{ item.numpropertiesowned }}</span></div>
              <div class="rm-detail-field" v-if="item.totalportfoliovalue"><span class="rm-detail-label">Portfolio Value</span><span class="rm-detail-value">{{ item.totalportfoliovalue }}</span></div>
              <div class="rm-detail-field rm-detail-field--full" v-if="item.portfoliodescription"><span class="rm-detail-label">Portfolio Description</span><span class="rm-detail-value">{{ item.portfoliodescription }}</span></div>
            </div>
          </div>

        </div>

        <!-- ── Footer ── -->
        <div class="rm-detail-footer">
          <button class="rm-detail-footer-close" @click="$emit('close')">
            <i class="fa-solid fa-xmark"></i>&nbsp; Close
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CommercialLoanDetailModal',

  props: {
    open: { type: Boolean, default: false },
    item: { type: Object, default: () => ({}) }
  },

  emits: ['close'],

  methods: {
    boolLabel(v) {
      if (v === true  || v === 1) return 'Yes'
      if (v === false || v === 0) return 'No'
      return '—'
    },
    boolBadge(v) {
      if (v === true  || v === 1) return 'badge--yes'
      if (v === false || v === 0) return 'badge--no'
      return 'badge--neutral'
    }
  }
}
</script>

<style scoped>
/* Identical styles to ReverseMortgageDetailModal */
.rm-detail-overlay { position: fixed; inset: 0; z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; background: rgba(10, 20, 40, 0.6); backdrop-filter: blur(4px); }
.rm-detail-modal { background: #f0f3f8; border-radius: 8px; width: 100%; max-width: 900px; max-height: 88vh; border: 1px solid #d4daea; box-shadow: 0 8px 32px rgba(10, 20, 40, 0.18); overflow: hidden; display: flex; flex-direction: column; }
.rm-detail-header { display: flex; align-items: center; justify-content: space-between; padding: 14px 18px; background: #f0f3f8; border-bottom: 1px solid #d4daea; flex-shrink: 0; }
.rm-detail-header-left { display: flex; align-items: center; gap: 12px; }
.rm-detail-header-left > i { font-size: 2.2rem; color: #5a7fc4; flex-shrink: 0; }
.rm-detail-title { margin: 0; font-size: 1.6rem; font-weight: 700; color: #28344f; }
.rm-detail-subtitle { margin: 2px 0 0; font-size: 1.3rem; color: #6f7b92; font-weight: 500; }
.rm-detail-close { width: 32px; height: 32px; border: 1px solid #c6cfe3; background: #dce2ef; border-radius: 5px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 1.4rem; color: #4a5675; transition: all 0.15s ease; flex-shrink: 0; }
.rm-detail-close:hover { background: #fecaca; border-color: #f87171; color: #b91c1c; }
.rm-detail-meta-bar { display: flex; align-items: center; flex-wrap: wrap; gap: 4px 20px; padding: 8px 18px; background: #e8ecf4; border-bottom: 2px solid #c6cfe3; flex-shrink: 0; }
.rm-detail-meta-item { display: flex; align-items: center; gap: 6px; font-size: 1.25rem; font-weight: 600; color: #4a5675; }
.rm-detail-meta-item i { color: #5a7fc4; font-size: 1.2rem; }
.rm-detail-body { overflow-y: auto;  flex-direction: column; gap: 12px; padding: 16px 18px; }
.rm-detail-section { background: #fbfbfd; border: 1px solid #e7ebf2; border-radius: 5px; overflow: hidden; }
.rm-detail-section-header { display: flex; align-items: center; gap: 8px; padding: 9px 14px; background: #f0f3f8; border-bottom: 1px solid #d4daea; font-size: 1.2rem; font-weight: 700; color: #6f7b92; text-transform: uppercase; letter-spacing: 0.07em; }
.rm-detail-section-header i { font-size: 1.3rem; color: #5a7fc4; }
.rm-detail-grid { display: grid; grid-template-columns: repeat(3, 1fr); }
.rm-detail-field { display: flex; flex-direction: column; gap: 4px; padding: 10px 14px; border-bottom: 1px solid #edf0f5; border-right: 1px solid #edf0f5; background: #fbfcfe; }
.rm-detail-field:hover { background: #eaf0fb !important; }
.rm-detail-field:nth-child(3n) { border-right: none; }
.rm-detail-field--full { grid-column: 1 / -1; border-right: none; background: #fbfcfe !important; }
.rm-detail-label { font-size: 1.05rem; font-weight: 700; color: #6f7b92; text-transform: uppercase; letter-spacing: 0.06em; line-height: 1; }
.rm-detail-value { font-size: 1.35rem; color: #23314f; font-weight: 500; line-height: 1.4; word-break: break-word; }
.rm-detail-badge { display: inline-flex; align-items: center; justify-content: center; padding: 2px 10px; border-radius: 20px; font-size: 1.1rem; font-weight: 700; width: fit-content; margin-top: 3px; }
.badge--yes { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
.badge--no { background: #fee2e2; color: #b91c1c; border: 1px solid #fecaca; }
.badge--neutral { background: #dce2ef; color: #6f7b92; border: 1px solid #c6cfe3; }
.rm-detail-footer { padding: 12px 18px; background: #fafbfd; border-top: 1px solid #e9edf3; display: flex; justify-content: flex-end; flex-shrink: 0; }
.rm-detail-footer-close { display: inline-flex; align-items: center; gap: 6px; padding: 7px 18px; height: 34px; border-radius: 5px; border: 1px solid #d9dfeb; background: #ffffff; font-size: 1.3rem; font-weight: 600; color: #22314f; cursor: pointer; transition: background 0.15s ease, border-color 0.15s ease; }
.rm-detail-footer-close:hover { background: #f4f7fc; border-color: #cfd8e8; }
.rm-modal-fade-enter-active, .rm-modal-fade-leave-active { transition: opacity 0.18s ease; }
.rm-modal-fade-enter-active .rm-detail-modal, .rm-modal-fade-leave-active .rm-detail-modal { transition: transform 0.2s cubic-bezier(0.34, 1.1, 0.64, 1), opacity 0.18s ease; }
.rm-modal-fade-enter-from, .rm-modal-fade-leave-to { opacity: 0; }
.rm-modal-fade-enter-from .rm-detail-modal, .rm-modal-fade-leave-to .rm-detail-modal { transform: translateY(12px) scale(0.98); opacity: 0; }
@media (max-width: 700px) {
  .rm-detail-overlay { padding: 0; align-items: flex-end; }
  .rm-detail-modal { border-radius: 12px 12px 0 0; }
  .rm-detail-grid { grid-template-columns: repeat(2, 1fr); }
  .rm-detail-field:nth-child(3n) { border-right: 1px solid #edf0f5; }
  .rm-detail-field:nth-child(2n) { border-right: none; }
}
</style>
